import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const NotFoundPage = () => (
  <div data-testid="not-found-page" className="bg-white min-h-screen flex items-center justify-center">
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center px-6 max-w-lg"
    >
      <div className="text-8xl font-extrabold text-[#0B3A82]/10 mb-4 font-['Manrope']">404</div>
      <h1 className="text-2xl font-bold text-[#1A1A2E] mb-3">Sayfa bulunamadı.</h1>
      <p className="text-[#64748B] mb-10">Aradığınız sayfa mevcut değil veya taşınmış olabilir.</p>
      <Link to="/">
        <Button className="bg-[#FF6B2C] hover:bg-[#E55A1F] text-white rounded-full font-semibold px-8 py-3 group" data-testid="404-home-button">
          Ana sayfaya dön <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Button>
      </Link>
    </motion.div>
  </div>
);

export default NotFoundPage;
